const getLocalStorage = item => JSON.parse(localStorage.getItem(item))

export default getLocalStorage
